import { InjectionToken } from '@angular/core';
import { DocumentsStore } from './+state/documents.store';
import { DEFAULT_DOCUMENTS_CONFIG, DocumentsConfig } from './documents.config';
import { DocumentsService } from './services/documents.service';

export const DOCUMENTS_CONFIG = new InjectionToken<DocumentsConfig>(
  'Documents config',
);

export const provideDocuments = (
  config: DocumentsConfig | (() => DocumentsConfig),
) => {
  return [
    {
      provide: DOCUMENTS_CONFIG,
      // useFactory runs in the route's injection context, so config factories
      // may call inject() and capture dependencies in closures.
      useFactory: () => ({
        ...DEFAULT_DOCUMENTS_CONFIG,
        ...(typeof config === 'function' ? config() : config),
      }),
    },
    DocumentsService,
    DocumentsStore,
  ];
};
